/**
 * Detect well-known in-app browsers (Instagram/Facebook/TikTok/Snapchat) where
 * the Firebase JS SDK and other browser APIs are flaky. Surfaces a banner that
 * deeplinks the user to Safari/Chrome.
 */
export const isInAppBrowser = (ua: string = navigator.userAgent): boolean => {
  const patterns = [
    /Instagram/i,
    /FBAN|FBAV/i,        // Facebook
    /TikTok|musical_ly/i,
    /Snapchat/i,
    /Line\//i,
    /MicroMessenger/i,   // WeChat
  ];
  return patterns.some((re) => re.test(ua));
};

export const buildSafariUrl = (currentUrl: string): string => {
  // x-safari-https:// scheme is iOS-specific; fallback to plain url for Android.
  if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
    return currentUrl.replace(/^https/, "x-safari-https");
  }
  return currentUrl;
};

export const buildChromeIntent = (currentUrl: string): string => {
  // Android: "intent://" deeplink to open in Chrome.
  if (/Android/.test(navigator.userAgent)) {
    const stripped = currentUrl.replace(/^https?:\/\//, "");
    return `intent://${stripped}#Intent;scheme=https;package=com.android.chrome;end`;
  }
  return currentUrl;
};
